import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import css from './FeedTabs.module.css';
import { ACTIVITY, feedArray, MARKETPLACE, SAVED_POST } from '../../../../util/types';
import { Button } from '../../../../components';
import { FormattedMessage } from 'react-intl';
import { requestGroupPermissionModal, setElephantVerificationModal } from '../../../../ducks/user.duck';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../../util/routes';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
import { checkElephantModalOpen } from '../../../../util/data';

export default function FeedTabs(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const routeConfiguration = useRouteConfiguration();
  const { currentUser } = useSelector(state => state.user);
  const isLogin = !!(currentUser && currentUser.id);

  const {
    activeTab,
    handleTabClick,
    checkCreateGroupAuth,
    onRequestGroupClick,
    handleCreateListingClick,
    userNotFound = false,
    isLoggedInAs = false,
    userAbilityToSell = false,
    hideTabs = [],
  } = props;

  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  const addRequestGroupQueryParam = () => {
    const searchParams = new URLSearchParams(location.search || '');
    searchParams.set('requestGroup', 'true');

    history.push({
      pathname: location.pathname,
      search: `?${searchParams.toString()}`,
      hash: location.hash,
    });
  };

  const handleRequestToGroup = () => {
    if (!isLogin) {
      return history.push(createResourceLocatorString('SignupPage', routeConfiguration, {}, {}));
    }
    const isOpenElephantModal = checkElephantModalOpen(currentUser);
    if (isOpenElephantModal) {
      dispatch(setElephantVerificationModal(true));
      return;
    }
    if (!checkCreateGroupAuth) {
      dispatch(requestGroupPermissionModal(true));
      return;
    }
    addRequestGroupQueryParam();
    onRequestGroupClick(true)
  };

  return (<>
    <div className={css.communityMenu}>Community Menu</div>
    <div className={!isLoggedInAs ? css.tabsContainer : css.tabsContainer2}>
      {feedArray
        .filter(item => {
          // Hide Saved Posts and My Activity for logged-out users
          if (!isLogin && (item.tab === SAVED_POST || item.tab === ACTIVITY)) {
            return false;
          }
          // Hide for userNotFound
          if (userNotFound && (item.tab === SAVED_POST || item.tab === ACTIVITY)) {
            return false;
          }
          return !hideTabs.includes(item.tab);
        })
        .map(item => (
          <div
            key={item.tab}
            data-testid={`feed-tab-${item.tab}`}
            className={`${css.feedContainer} ${activeTab === item.tab ? css.activeTab : ''}`}
            onClick={() => handleTabClick(item)}
          >
            <span className={css.icon}>{item.Icon}</span>
            <span>{item.text}</span>
          </div>
        ))}
      {activeTab === MARKETPLACE ? (
        <Button className={css.requestButton} disabled={!userAbilityToSell || !isLogin} type="button" onClick={handleCreateListingClick}>
          <FormattedMessage id="AlgoliaSearchPage.createListingButton" />
        </Button>
      ) : !userNotFound ? (
        <Button className={css.requestButton} type="button" onClick={handleRequestToGroup}>
          <FormattedMessage id="CircleFeedPage.requestGroupButton" /> 
        </Button>
      ) : null}
          {/* <div className={css.spacer}></div> */}

      {!isLogin && (
        <>
          <Button 
            className={css.authButton} 
            type="button" 
            onClick={() => history.push(createResourceLocatorString('SignupPage', routeConfiguration, {}, {}))}
          >
                          <ProfileIconCard type="join_now"/>
            <FormattedMessage id="CircleFeedPage.joinNowButton" defaultMessage="Join Now" />
          </Button>
          <Button 
            className={css.authButton} 
            type="button" 
            onClick={() => history.push(createResourceLocatorString('LoginPage', routeConfiguration, {}, {}))}
          >
                            <ProfileIconCard type="join_now"/>
            <FormattedMessage id="CircleFeedPage.loginButton" defaultMessage="Log In" />
          </Button>
        </>
      )}
    </div>
  </>
  );
}
